import dateTimeHelper from '../../../Helpers/datetimeHelper';
import UserService from '../../../Services/userService';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import selectHelper from '../../../Helpers/selectHelper';
import SearchParamsBase from '../../../Elements/SearchParamsBase';
import FeeTypesEnum from '../../../Enums/FeeTypesEnum';

export default class FreelancerFeeSearchParams extends SearchParamsBase {
  constructor(id) {
    super();
    if (id !== undefined) {
      this.FreelancerUserIdOrName = id.toString();
      this.Office = [];
    }
  }

  initialize() {
    this.FreelancerFeeId = '';
    this.FreelancerUserIdOrName = '';
    this.ClientIdOrName = '';
    this.SurveyIdOrName = '';
    this.TpSurveyIdOrName = '';
    this.CountryIdOrName = '';
    this.UseDateRange = false;
    this.StartDate = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.firstDayOfTheActualMonth());
    this.EndDate = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.indefiniteDateValue());
    this.SelfAssigned = '';
    this.Office = OfficeHelper.GetDefaultOfficeIds(UserService.GetOfficeIdOfLoggedInUser());
    this.FeeType = '';
    this.TimeBased = '';
  }

  static fieldsInSearchBox = [
    { fieldName: 'FreelancerFeeId', label: 'Vendor Fee Id', className: 'col-3', type: InputTypesEnum.Text },
    {
      fieldName: 'FreelancerUserIdOrName',
      label: 'Vendor (Id or Name)',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'Office',
      label: 'Office',
      className: 'col-3',
      type: InputTypesEnum.OfficeOrGroupSelect,
      roleKey: 'Freelancer_inputfield_VendorAdminFinanceAdmin',
    },
    {
      fieldName: 'FeeType',
      label: 'Fee Type',
      className: 'col-3',
      type: InputTypesEnum.Select,
      options: FreelancerFeeSearchParams.getSelectValuesForFeeType(),
    },
    {
      fieldName: 'ClientIdOrName',
      label: 'Client (SassieId or Third-Party ID or Name)',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    { fieldName: 'SurveyIdOrName', label: 'Survey (SassieId or Name)', className: 'col-3', type: InputTypesEnum.Text },
    {
      fieldName: 'TpSurveyIdOrName',
      label: 'TpSurvey (ThirdPartyId or Name)',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    { fieldName: 'CountryIdOrName', label: 'Country', className: 'col-3', type: InputTypesEnum.Text },
    { fieldName: 'TimeBased', label: 'Time-based', className: 'col-3', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'UseDateRange', label: 'Use Date Range', className: 'col-3', type: InputTypesEnum.OnOff },
    {
      fieldName: 'StartDate',
      label: 'Start Date',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateRange,
    },
    {
      fieldName: 'EndDate',
      label: 'End Date',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateRange,
    },
    { fieldName: 'SelfAssigned', label: 'Self Assigned', className: 'col-3', type: InputTypesEnum.Bool },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'FreelancerFeeSearchParams';

  //---------------------------

  static getSelectValuesForFeeType() {
    return selectHelper.generateSelectValues([
      '',
      FeeTypesEnum.Resource,
      FeeTypesEnum.DataQuality,
      FeeTypesEnum.KAM,
      FeeTypesEnum.BD,
      FeeTypesEnum.BI,
      FeeTypesEnum.IT,
      FeeTypesEnum.HR,
      FeeTypesEnum.Marketing,
      FeeTypesEnum.Finance,
      FeeTypesEnum.FieldworkPartner,
    ]);
  }
}
